import { IConfigState, ConfigActionTypes, ChangeConfigSuccessActionType, InitConfigActionType } from "./types";
import { Handler } from "./../types/store-types";

const changeConfigs: Handler<IConfigState, ChangeConfigSuccessActionType> = (state, { payload }) => {
    return { ...state, config: { ...payload.config } };
};

const initConfigs: Handler<IConfigState, InitConfigActionType> = (state, { payload }) => {
    return { ...state, config: { ...payload.config } };
};

export const handlersConfigs = {
    [ConfigActionTypes.CHANGE_CONFIGS_SUCCESS]: changeConfigs,
    [ConfigActionTypes.INIT_CONFIGS]: initConfigs,
};
